import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ActivityPage } from './pages/ActivityPage';
import { AboutPage } from './pages/AboutPage';
import { BookNowPage } from './pages/BookNowPage';
import { RegionalBookingPage } from './pages/RegionalBookingPage';
import { EventBookingPage } from './pages/EventBookingPage';
import { MedalsPage } from './pages/MedalsPage';
import { BadmintonPage } from './pages/BadmintonPage';
import { BecomeACoachPage } from './pages/BecomeACoachPage';
import { LegalPage } from './pages/LegalPage';
import { ContactSection } from './components/ContactSection';
import { SponsorStrip } from './components/SponsorStrip';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen font-sans text-navy-900 bg-white" data-id="element-1">
        <Header data-id="element-2" />

        <div className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/activities/:slug" element={<ActivityPage data-id="element-8" />} data-id="element-7" />
            <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
            <Route path="/book" element={<BookNowPage data-id="element-12" />} data-id="element-11" />
            <Route path="/book/:region" element={<RegionalBookingPage data-id="element-14" />} data-id="element-13" />
            <Route path="/book/:region/:sessionId" element={<EventBookingPage data-id="element-16" />} data-id="element-15" />
            <Route path="/medals" element={<MedalsPage data-id="element-18" />} data-id="element-17" />
            <Route path="/badminton" element={<BadmintonPage data-id="element-20" />} data-id="element-19" />
            <Route path="/become-a-coach" element={<BecomeACoachPage data-id="element-22" />} data-id="element-21" />
            <Route path="/legal" element={<LegalPage data-id="element-24" />} data-id="element-23" />
          </Routes>
        </div>

        <SponsorStrip data-id="element-25" />
        <ContactSection data-id="element-26" />
        <Footer data-id="element-27" />
      </div>
    </Router>;
}